import { Heart } from "lucide-react";

export default function DateStrip() {
  return (
    <section
      data-testid="wedding-date-strip"
      className="border-y border-[#E5D5B8] bg-gradient-to-r from-transparent via-[#FBF6E9] to-transparent py-6"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
        <span className="font-display text-sm tracking-[0.34em] text-[#57534E]">17.11.2026</span>
        <Heart size={15} className="text-[#D4AF37]" fill="currentColor" aria-hidden="true" />
        <span className="font-script text-4xl leading-none text-[#8C6515]">Wedding Day</span>
      </div>
    </section>
  );
}
